import React from 'react';
import Button, { ButtonModeE } from '../../components/Button/Button';
import usePopup from './../../utils/hooks/usePopup';

import styles from './createNewAdvertiserShort.module.scss';

const CreateNewAdvertiserShortFooter = () => {
    const { removePopup } = usePopup();

    return (
        <div className={styles.buttonsWrapper}>
            <Button mode={ButtonModeE.OUTLINED} onClick={removePopup}>Cancel</Button>
            <Button form='create-advertiser-short' useGlobalLoading >Save advertiser</Button>
        </div>
    );
};

export default CreateNewAdvertiserShortFooter;